import { useState, useRef, useEffect } from "react";
import { HeaderBackTitle } from "../common/header";
import _ from "lodash";
import { IconVehicle } from "../common/icon";
import { _postURL } from "@/api/index";
import { VehicleBrandModal } from "../modal";
import { _getAllVehicleBrandList, generateFilterToUrl } from "../../libraries/common";
import Link from 'next/link';
import { mobileViewWidth, pageLink, priceOption } from "../../config/site";
import Redux from "@/action";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";

const filterCatergory = [
    {value: "brand", label: "brand"},
    {value: "price", label: "price"},
    {value: "bodyType", label: "body_type"},
    {value: "segment", label: "segment"},
    {value: "transmission", label: "transmission"},
    {value: "fuel", label: "fuel"},
    {value: "seats", label: "seats"},
    {value: "driveline", label: "driveline"},
    {value: "featuresSpecs", label: "features_specs"},
]

const bodyTypeList = [
    {value: 'sedan', label: 'sedan'},
    {value: 'hatchback', label: 'hatchback'},
    {value: 'suv', label: 'suv'},
    {value: 'cabriolet', label: 'cabriolet'},
    {value: 'sport', label: 'sport'},
    {value: 'mpv', label: 'mpv'},
    {value: 'truck', label: 'truck'},
    {value: 'wagon', label: 'wagon'},
    {value: 'pickup', label: 'pickup'}
]

const otherList = [
    {
        category: "segment", 
        categoryName: "segment",
        item: [
            {value: 'A-Segment', label: 'A-Segment'},
            {value: 'B-Segment', label: 'B-Segment'},
            {value: 'C-Segment', label: 'C-Segment'},
            {value: 'D-Segment', label: 'D-Segment'},
            {value: 'E-Segment', label: 'E-Segment'},
            {value: 'Commercial', label: 'Commercial'},
            {value: 'Executive', label: 'Executive'},
            {value: 'Grand Tourer', label: 'Grand Tourer'},
            {value: 'Luxury', label: 'Luxury'},
            {value: 'Sports Car', label: 'Sports Car'},
            {value: 'Super Car', label: 'Super Car'},
            {value: 'Compact Executive', label: 'Compact Executive'},
            {value: '4x4', label: '4x4'},
        ]
    },
    {
        category: "transmission", 
        categoryName: "transmission",
        item: [
            {value: 'MT', label: 'MT'},
            {value: 'AMT', label: 'AMT'},
            {value: 'CVT', label: 'CVT'},
            {value: 'DCT', label: 'DCT'},
            {value: 'AT', label: 'AT'},
            {value: 'MCT', label: 'MCT'},
            {value: 'EV', label: 'EV'},
            {value: 'E-CVT', label: 'E-CVT'},
        ]
    },
    {
        category: "fuel", 
        categoryName: "fuel",
        item: [
            {value: 'Petrol', label: 'Petrol'},
            {value: 'Diesel', label: 'Diesel'},
            {value: 'Petrol Hybrid', label: 'Petrol Hybrid'},
            {value: 'EV', label: 'EV'},
        ]
    },
    {
        category: "seats", 
        categoryName: "seats",
        item: [
            {value: '2', label: '2 Seats'},
            {value: '4', label: '4 Seats'},
            {value: '5', label: '5 Seats'},
            {value: '6', label: '6 Seats'},
            {value: '7', label: '7 Seats'},
            {value: '8', label: '8 Seats'},
            {value: '10', label: '10 Seats'},
            {value: '11', label: '11 Seats'},
            {value: '12', label: '12 Seats'},
            {value: '15', label: '15 Seats'},
        ]
    },
    {
        category: "driveline", 
        categoryName: "driveline",
        item: [
            {value: 'Front Wheel Drive', label: 'Front Wheel Drive'},
            {value: 'Rear Wheel Drive', label: 'Rear Wheel Drive'},
            {value: 'All Wheel Drive', label: 'All Wheel Drive'},
        ]
    },
    {
        category: "featuresSpecs", 
        categoryName: "features_specs",
        item: [
            {value: 'cruise_control', label: 'Cruise Control'},
            {value: 'hill_start_assist', label: 'Hill Start Assist'},
            {value: 'sunroof', label: 'Sunroof'},
            {value: 'paddle_shift', label: 'Paddle Shift'},
            {value: 'sunshade', label: 'Sunshade'},
            {value: 'bluetooth', label: 'Car Bluetooth'},
            {value: 'isofix', label: 'ISOFIX'},
            {value: 'abs_ebd', label: 'ABS System'},
        ]
    },
]

const MAX_LENGTH = 6;

const SelectedButton = (props) => {
    const { label = "", isActive = false, handleOnClick = ()=>{} } = props
    return (
        <div onClick={handleOnClick} className={isActive == true ? "vehicleFilter_brand_item cursorPointer vehicleFilter_brand_item_active" : "vehicleFilter_brand_item cursorPointer"}>
            <p className={`fontSize_14 ${isActive == true ? "fontWeight_semiBold fontColor_white" : "fontColor_grey4"}`}>
                {label}
            </p>
        </div>
    )
}

export const VehicleFilter = (props) => {
    const { t, device, session, params, fetchedData } = props
    const { store, dispatch } = Redux();
    const [category, setCategory] = useState("brand")
    const [filter, setFilter] = useState({brand: [], price: [], bodyType: [], segment: [], transmission: [], fuel: [], seats: [], driveline: [], featuresSpecs: []})
    const filterSections = useRef({});
    const [filterResultCount, setFilterResultCount] = useState(fetchedData.model);
    const [filterLink, setFilterLink] = useState('');

    // vehicle brand moal
    const [vehicleBrandModalOpen, setVehicleBrandModalOpen] = useState(false)

    const _handleOnClick = (value, type) => {
        setFilter((prevFilter)=> {
            let filterData = [...prevFilter[type]]
            if(_.includes(prevFilter[type], value) ){
                // remove value then already inside array
                filterData = _.filter(prevFilter[type], (item) => item != value);
            } else {
                // merge push value in array
                filterData = _.uniq([...prevFilter[type], value])
            }
            
            let newFilter = { ...prevFilter, [type]: filterData };
            if(type == "brand"){
                // brand only max 6 push new value will delete first value
                if (newFilter["brand"].length > MAX_LENGTH) {
                    newFilter["brand"] = _.takeRight(newFilter["brand"], MAX_LENGTH);
                }
            }
            return newFilter;
        })
    }

    const _handleIndexItemClick = (category) => {
        setCategory(category)
        const sectionElement = document.querySelector(`.contentContainer`); // the modal class name 
        if (filterSections.current[category] && sectionElement) {

            const targetSection = filterSections.current[category];
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' }); // scroll to that category character title
            // const scrollAmount = -modalHeaderRef?.current?.offsetHeight;
            
            const currentScrollPosition = sectionElement.scrollTop; // get current position
            const targetOffsetTop = targetSection.getBoundingClientRect().top; // between this category character with scroll top height
            const headerHeight = filterSections?.current?.[Object.keys(filterSections?.current)[0]]?.getBoundingClientRect().top // get 1st category character between scroll top height
            const scrollAmount = -(currentScrollPosition + headerHeight) // - the header height 
            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: currentScrollPosition + targetOffsetTop + scrollAmount,
                    behavior: 'smooth'
                });
            } else {
                sectionElement.scrollTo({
                    top: currentScrollPosition + targetOffsetTop + scrollAmount,
                    behavior: 'smooth'
                });
            }
            
        }
    };

    const _setDefaultAllFilterValue = () => {
        setFilter({brand: [], price: [], bodyType: [], segment: [], transmission: [], fuel: [], seats: [], driveline: [], featuresSpecs: []});
        setFilterResultCount(fetchedData.model);
    }

    useEffect(() => {
        const fetchData = async() => {
            try {
                let req = filter;
                let result = await _postURL("/api/vehicle/getVehicleFilterCount", {...req});
                if(result?.data){
                    setFilterResultCount(result.data.total)
                    let filterLink = generateFilterToUrl(filter)
                    if (!_.isEmpty(filterLink)) {
                        setFilterLink('?'+filterLink);
                    }
                }
            } catch(error) {
                console.log(error);
            }
        }
        fetchData()
    }, [filter]);

    useEffect(()=>{
        const fetchData = async()=>{
            try{
                if(_.isEmpty(store?.path?.dataAllVehicleBrandList)){
                    await _getAllVehicleBrandList(dispatch);
                }
            } catch(error) {
                console.log(error)
            } finally {

            }
        }
        fetchData()
    },[])

    return (
        <>
            <AllMeta
                title={t('vehicleFilterPage_meta_title')}
                description={t('vehicleFilterPage_meta_description')}
                keyword={t('vehicleFilterPage_meta_keyword')}
            />
            <Head><title>{t('vehicleFilterPage_title')}</title></Head>
            <MyBody
                t={t}
                containerStyle={{overflowX: 'hidden'}}
                showFooter={false}
                headerComponent={
                    <div className="vehicleFilterHeader">
                        <HeaderBackTitle 
                            title={t("car_filter")} 
                            showSearch={false}
                            showMenu={false}
                            t={t}
                        />
                        <div className="vehicleFilterHeader_leftCat" style={store?.path?.isLoadedInFlutterApp == true ? {top: 0} : {}}>
                            {
                                _.reduce(filterCatergory, (result, value, key)=>{
                                    result.push(
                                        <div key={key} onClick={()=>{_handleIndexItemClick(value.value)}} className={category == value.value ? "vehicleFilter_left_item cursorPointer vehicleFilter_left_item_active" : "vehicleFilter_left_item cursorPointer"}>
                                            {
                                                category == value.value &&
                                                <div className="vehicleFilter_left_item_activeLine" />
                                            }
                                            <p className={category == value.value ? "fontSize_12 fontWeight_semiBold" : "fontSize_12"}>
                                                {t(value.label)}
                                            </p>
                                        </div>
                                    )
                                    return result
                                },[])
                            }
                        </div>
                    </div>
                }
                showNavigation={true}
                navigationComponent={
                    <div className="vehicleFilter_bottomNavigation containerPadding">
                        <div className="vehicleFilter_bottomNavigation_reset">
                            <p className="fontSize_16 fontWeight_medium fontColor_red cursorPointer" onClick={() => {_setDefaultAllFilterValue()}}>
                                {t('reset')}
                            </p>
                        </div>
                        <CustomLink href={pageLink.vehicle.filterResult+filterLink}>
                            <div className="vehicleFilter_bottomNavigation_search cursorPointer">
                                <p className="fontSize_16 fontWeight_bold fontColor_white">
                                    {t('search')}
                                </p>
                                <p className="fontSize_12 fontWeight_medium fontColor_white">
                                    {`(${filterResultCount} ${t('found')})`}
                                </p>
                            </div>
                        </CustomLink>
                    </div>
                }
                modalComponent={
                    <VehicleBrandModal 
                        t={t}
                        vehicleBrandModalOpen={vehicleBrandModalOpen}
                        setVehicleBrandModalOpen={setVehicleBrandModalOpen}
                        handleClickBrandItem={(value)=>{_handleOnClick(value?.brand_custom_url, "brand")}}
                        activeList={filter?.["brand"]}
                        vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
                        isMultipleModal={false}
                    />
                }
            >
                <div className="vehicleFilter">
                    <div className="vehicleFilter_left" />
                    <div className="vehicleFilter_right">
                        <div ref={(ref) => (filterSections.current["brand"] = ref)} className="vehicleFilter_brand">
                            <p className="fontSize_16 fontWeight_semiBold">
                                {t('brand')}
                            </p>
                            <div className="vehicleFilter_brand_content">
                                {
                                    _.reduce(fetchedData.filter, (result, value, key)=>{
                                        result.push(
                                            <SelectedButton
                                                key={key} 
                                                label={value.label}
                                                handleOnClick={()=>{_handleOnClick(value.value, "brand")}}
                                                isActive={!_.isEmpty(filter?.["brand"]) ? _.includes(filter?.["brand"], value.value) : false}
                                            />
                                        )
                                        return result
                                    },[])
                                }
                                <div onClick={()=>{setVehicleBrandModalOpen(true)}} className="vehicleFilter_brand_item vehicleFilter_brand_selectMore cursorPointer">
                                    <p className="fontSize_14 fontColor_grey4">
                                        {t('select_more_brands')}
                                    </p>
                                    <div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ref={(ref) => (filterSections.current["price"] = ref)} className="vehicleFilter_price">
                            <p className="fontSize_16 fontWeight_semiBold">
                                {t('price')}
                            </p>
                            <div className="vehicleFilter_price_content">
                                {/* <Slider
                                    defaultValue={0}
                                    min={0}
                                    max={3000}
                                    label={(value) => `${value}K`}
                                    step={10}
                                    labelAlwaysOn={true}
                                    classNames={{
                                        track: "mantineCustome-Slider-track",
                                        markWrapper: "mantineCustome-Slider-markWrapper",
                                        mark: "mantineCustome-Slider-mark",
                                        bar: "mantineCustome-Slider-bar",
                                        thumb: "mantineCustome-Slider-thumb",
                                        label: "fontSize_14 mantineCustome-Slider-label",
                                        markLabel: "fontSize_14 mantineCustome-Slider-markLabel"
                                    }}
                                    marks={[
                                        { value: 0, label: '0' },
                                        { value: 600, label: '600K' },
                                        { value: 3000, label: '3000K' },
                                    ]}
                                    onChangeEnd={(value)=>{_handleOnClick(value, "price")}}
                                    // styles={{ markLabel: { display: 'none' } }}
                                /> */}
                                {/* <RangeSlider 
                                    min={0}
                                    max={3000}
                                    label={(value) => `${kFormatter(value * 1000)}`}
                                    step={10}
                                    labelAlwaysOn={true}
                                    classNames={{
                                        track: "mantineCustome-Slider-track",
                                        markWrapper: "mantineCustome-Slider-markWrapper",
                                        mark: "mantineCustome-Slider-mark",
                                        bar: "mantineCustome-Slider-bar",
                                        thumb: "mantineCustome-Slider-thumb",
                                        label: "fontSize_14 mantineCustome-Slider-label",
                                        markLabel: "fontSize_14 mantineCustome-Slider-markLabel"
                                    }}
                                    marks={[
                                        { value: 0, label: '0' },
                                        { value: 600, label: '600K' },
                                        { value: 3000, label: '3M' },
                                    ]}
                                    onChangeEnd={(value)=>{_handleOnClick(value, "price")}}
                                /> */}
                                {
                                    _.reduce(priceOption, (result, value, key)=>{
                                        result.push(
                                            <SelectedButton
                                                key={key} 
                                                label={value.label}
                                                handleOnClick={()=>{_handleOnClick(value.value, "price")}}
                                                isActive={!_.isEmpty(filter?.["price"]) ? _.includes(filter?.["price"], value.value) : false}
                                            />
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </div>
                        <div ref={(ref) => (filterSections.current["bodyType"] = ref)} className="vehicleFilter_bodyType">
                            <p className="fontSize_16 fontWeight_semiBold">
                                {t('body_type')}
                            </p>
                            <div className="vehicleFilter_bodyType_content">
                                {
                                    _.reduce(bodyTypeList, (result, value, key)=>{
                                        result.push(
                                            <div 
                                                onClick={()=>{_handleOnClick(value.value, "bodyType")}} 
                                                key={key} 
                                                className="vehicleFilter_bodyType_item cursorPointer"
                                            >
                                                <div>
                                                    <IconVehicle
                                                        color={!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "#E91C21" : undefined}
                                                        type={value.value}
                                                    />
                                                </div>
                                                <p className={ `fontSize_14 ${!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "fontColor_red" : "fontColor_grey4"}` }>
                                                    {value.label}
                                                </p>
                                            </div>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </div>
                        {
                            _.reduce(otherList, (result, value, key)=>{
                                result.push(
                                    <div ref={(ref) => (filterSections.current[value.category] = ref)} key={key} className="vehicleFilter_list">
                                        <p className="fontSize_16 fontWeight_semiBold">
                                            {t(value.categoryName)}
                                        </p>
                                        <div className="vehicleFilter_list_content">
                                            {
                                                _.reduce(value?.item, (result2, value2, key2)=>{
                                                    result2.push(
                                                        <SelectedButton
                                                            key={`${key}-${key2}`} 
                                                            label={value2.label}
                                                            handleOnClick={()=>{_handleOnClick(value2.value, value.category)}}
                                                            isActive={!_.isEmpty(filter?.[value.category]) ? _.includes(filter?.[value.category], value2.value) : false}
                                                        />
                                                    )
                                                    return result2
                                                },[])
                                            }
                                        </div>
                                    </div>
                                )
                                return result
                            },[])
                        }
                    </div>
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('vehicleFilterPage_meta_title')}
    //             description={t('vehicleFilterPage_meta_description')}
    //             keyword={t('vehicleFilterPage_meta_keyword')}
    //         />
    //         <Head><title>{t('vehicleFilterPage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer bodyContainerHasBottomNavigation'  style={{overflowX: 'hidden'}}>
    //                 <div className="vehicleFilterHeader">
    //                     <div className="vehicleFilterHeader_inner">
    //                         <HeaderBackTitle 
    //                             title={t("car_filter")} 
    //                             showSearch={false}
    //                             showMenu={false}
    //                             t={t}
    //                         />
    //                     </div>
    //                     <div className="vehicleFilterHeader_leftCat">
    //                         {
    //                             _.reduce(filterCatergory, (result, value, key)=>{
    //                                 result.push(
    //                                     <div key={key} onClick={()=>{_handleIndexItemClick(value.value)}} className={category == value.value ? "vehicleFilter_left_item cursorPointer vehicleFilter_left_item_active" : "vehicleFilter_left_item cursorPointer"}>
    //                                         {
    //                                             category == value.value &&
    //                                             <div className="vehicleFilter_left_item_activeLine" />
    //                                         }
    //                                         <p className={category == value.value ? "fontSize_12 fontWeight_semiBold" : "fontSize_12"}>
    //                                             {t(value.label)}
    //                                         </p>
    //                                     </div>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </div>
    //                 <div className="vehicleFilter">
    //                     <div className="vehicleFilter_left" />
    //                     <div className="vehicleFilter_right">
    //                         <div ref={(ref) => (filterSections.current["brand"] = ref)} className="vehicleFilter_brand">
    //                             <p className="fontSize_16 fontWeight_semiBold">
    //                                 {t('brand')}
    //                             </p>
    //                             <div className="vehicleFilter_brand_content">
    //                                 {
    //                                     _.reduce(fetchedData.filter, (result, value, key)=>{
    //                                         result.push(
    //                                             <SelectedButton
    //                                                 key={key} 
    //                                                 label={value.label}
    //                                                 handleOnClick={()=>{_handleOnClick(value.value, "brand")}}
    //                                                 isActive={!_.isEmpty(filter?.["brand"]) ? _.includes(filter?.["brand"], value.value) : false}
    //                                             />
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                                 <div onClick={()=>{setVehicleBrandModalOpen(true)}} className="vehicleFilter_brand_item vehicleFilter_brand_selectMore cursorPointer">
    //                                     <p className="fontSize_14 fontColor_grey4">
    //                                         {t('select_more_brands')}
    //                                     </p>
    //                                     <div>

    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div ref={(ref) => (filterSections.current["price"] = ref)} className="vehicleFilter_price">
    //                             <p className="fontSize_16 fontWeight_semiBold">
    //                                 {t('price')}
    //                             </p>
    //                             <div className="vehicleFilter_price_content">
    //                                 {/* <Slider
    //                                     defaultValue={0}
    //                                     min={0}
    //                                     max={3000}
    //                                     label={(value) => `${value}K`}
    //                                     step={10}
    //                                     labelAlwaysOn={true}
    //                                     classNames={{
    //                                         track: "mantineCustome-Slider-track",
    //                                         markWrapper: "mantineCustome-Slider-markWrapper",
    //                                         mark: "mantineCustome-Slider-mark",
    //                                         bar: "mantineCustome-Slider-bar",
    //                                         thumb: "mantineCustome-Slider-thumb",
    //                                         label: "fontSize_14 mantineCustome-Slider-label",
    //                                         markLabel: "fontSize_14 mantineCustome-Slider-markLabel"
    //                                     }}
    //                                     marks={[
    //                                         { value: 0, label: '0' },
    //                                         { value: 600, label: '600K' },
    //                                         { value: 3000, label: '3000K' },
    //                                     ]}
    //                                     onChangeEnd={(value)=>{_handleOnClick(value, "price")}}
    //                                     // styles={{ markLabel: { display: 'none' } }}
    //                                 /> */}
    //                                 {/* <RangeSlider 
    //                                     min={0}
    //                                     max={3000}
    //                                     label={(value) => `${kFormatter(value * 1000)}`}
    //                                     step={10}
    //                                     labelAlwaysOn={true}
    //                                     classNames={{
    //                                         track: "mantineCustome-Slider-track",
    //                                         markWrapper: "mantineCustome-Slider-markWrapper",
    //                                         mark: "mantineCustome-Slider-mark",
    //                                         bar: "mantineCustome-Slider-bar",
    //                                         thumb: "mantineCustome-Slider-thumb",
    //                                         label: "fontSize_14 mantineCustome-Slider-label",
    //                                         markLabel: "fontSize_14 mantineCustome-Slider-markLabel"
    //                                     }}
    //                                     marks={[
    //                                         { value: 0, label: '0' },
    //                                         { value: 600, label: '600K' },
    //                                         { value: 3000, label: '3M' },
    //                                     ]}
    //                                     onChangeEnd={(value)=>{_handleOnClick(value, "price")}}
    //                                 /> */}
    //                                 {
    //                                     _.reduce(priceOption, (result, value, key)=>{
    //                                         result.push(
    //                                             <SelectedButton
    //                                                 key={key} 
    //                                                 label={value.label}
    //                                                 handleOnClick={()=>{_handleOnClick(value.value, "price")}}
    //                                                 isActive={!_.isEmpty(filter?.["price"]) ? _.includes(filter?.["price"], value.value) : false}
    //                                             />
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                             </div>
    //                         </div>
    //                         <div ref={(ref) => (filterSections.current["bodyType"] = ref)} className="vehicleFilter_bodyType">
    //                             <p className="fontSize_16 fontWeight_semiBold">
    //                                 {t('body_type')}
    //                             </p>
    //                             <div className="vehicleFilter_bodyType_content">
    //                                 {
    //                                     _.reduce(bodyTypeList, (result, value, key)=>{
    //                                         result.push(
    //                                             <div 
    //                                                 onClick={()=>{_handleOnClick(value.value, "bodyType")}} 
    //                                                 key={key} 
    //                                                 className="vehicleFilter_bodyType_item cursorPointer"
    //                                             >
    //                                                 <div>
    //                                                     <IconVehicle
    //                                                         color={!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "#E91C21" : undefined}
    //                                                         type={value.value}
    //                                                     />
    //                                                 </div>
    //                                                 <p className={ `fontSize_14 ${!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "fontColor_red" : "fontColor_grey4"}` }>
    //                                                     {value.label}
    //                                                 </p>
    //                                             </div>
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                             </div>
    //                         </div>
    //                         {
    //                             _.reduce(otherList, (result, value, key)=>{
    //                                 result.push(
    //                                     <div ref={(ref) => (filterSections.current[value.category] = ref)} key={key} className="vehicleFilter_list">
    //                                         <p className="fontSize_16 fontWeight_semiBold">
    //                                             {t(value.categoryName)}
    //                                         </p>
    //                                         <div className="vehicleFilter_list_content">
    //                                             {
    //                                                 _.reduce(value?.item, (result2, value2, key2)=>{
    //                                                     result2.push(
    //                                                         <SelectedButton
    //                                                             key={`${key}-${key2}`} 
    //                                                             label={value2.label}
    //                                                             handleOnClick={()=>{_handleOnClick(value2.value, value.category)}}
    //                                                             isActive={!_.isEmpty(filter?.[value.category]) ? _.includes(filter?.[value.category], value2.value) : false}
    //                                                         />
    //                                                     )
    //                                                     return result2
    //                                                 },[])
    //                                             }
    //                                         </div>
    //                                     </div>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="vehicleFilter_bottomNavigation containerPadding">
    //                 <div className="vehicleFilter_bottomNavigation_reset">
    //                     <p className="fontSize_16 fontWeight_medium fontColor_red cursorPointer" onClick={() => {_setDefaultAllFilterValue()}}>
    //                         {t('reset')}
    //                     </p>
    //                 </div>
    //                 <Link href={pageLink.vehicle.filterResult+filterLink}>
    //                     <div className="vehicleFilter_bottomNavigation_search cursorPointer">
    //                         <p className="fontSize_16 fontWeight_bold fontColor_white">
    //                             {t('search')}
    //                         </p>
    //                         <p className="fontSize_12 fontWeight_medium fontColor_white">
    //                             {`(${filterResultCount} ${t('found')})`}
    //                         </p>
    //                     </div>
    //                 </Link>
    //             </div>
    //             <VehicleBrandModal 
    //                 t={t}
    //                 vehicleBrandModalOpen={vehicleBrandModalOpen}
    //                 setVehicleBrandModalOpen={setVehicleBrandModalOpen}
    //                 handleClickBrandItem={(value)=>{_handleOnClick(value?.brand_custom_url, "brand")}}
    //                 activeList={filter?.["brand"]}
    //                 vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
    //                 isMultipleModal={false}
    //             />
    //         </div>
    //     </>
    // )
}